import { Select, TextField } from "@mui/material";
import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  /* Estilo para destacar inputs em edição */
  .highlighted-input .MuiOutlinedInput-notchedOutline {
    border-color: #2d5bff !important;
    border-width: 2px !important;
  }

  /* Estilo para deixar campos editáveis mais visíveis */
  .MuiTableRow-root:hover {
    background-color: rgba(45, 91, 255, 0.03);
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  border: 1px solid rgba(213, 213, 213, 0.6);
  background: #fff;
  padding: 8px;
  margin-top: 16px;
  margin-left: 12px;
  margin-right: 12px;
  margin-bottom: 16px;
`;

export const DataJurosText = styled.p`
  display: flex;
  align-items: center;
  //styleName: XXS/Regular;
  font-family: Inter;
  opacity: 0.6;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
`;

export const DataJurosInfo = styled.p`
  display: flex;
  align-items: center;
  //styleName: XXS/Regular;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
`;

export const ContentTable = styled.div`
  height: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    background-color: transparent;
    padding-bottom: 12px;
    width: 0px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }
`;

export const SecondContainer = styled.div`
  flex-direction: row;
  border-radius: 8px;
  border: 1px solid rgba(213, 213, 213, 0.6);
  background: #fff;
  padding: 8px;
  margin: 0px 12px 0px 12px;
`;

export const ObervationContainer = styled.div`
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  border-radius: 8px;
  background: #eaefff;
  padding: 12px;
  margin-top: 12px;
  height: auto;
  min-height: 45px;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

export const TextBlue = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: pre-wrap;
  color: #2d5bff;
`;

export const ObservationOculta = styled.div`
  display: block;
  width: fit-content;
  max-width: 100%;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: pre-wrap;
  color: transparent;
  background-color: rgba(45, 91, 255, 0.25);
  border-radius: 4px;
`;

export const Column: any = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${(props: any) => props?.flex};
`;

export const StrongText: any = styled.p`
  color: #101828;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 175% */
`;

export const LightText: any = styled.p`
  color: #101828;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 233.333% */
  opacity: 0.6;
`;

export const HorizontalLine = styled.hr`
  border: none;
  border-top: 1px solid black;
  margin: 5px 0;
  opacity: 10%;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Ocultar = styled.div`
  width: 100px;
  height: 20px;
  border-radius: 8px;
  background: #eaefff;
`;

export const StyledButton = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 8px;
  border-radius: 8px;
  background: #fff;
  color: #2d5bff;
  border: 2px solid #2d5bff;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const StyledSelect = styled(Select)`
  & .MuiOutlinedInput-notchedOutline {
    border-radius: 12px;
  }
  width: 100%;
`;

export const StyledTextField = styled(TextField)`
  & .MuiOutlinedInput-notchedOutline {
    border-radius: 12px;
  }
  width: 100%;
`;

export const MinButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eaefff !important;
  height: 40px;
  cursor: pointer;
  width: 10%;
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const Button = styled.button`
  border-radius: 8px;
  background: #eaefff !important;
  height: 40px;
  cursor: pointer;
  width: 100%;
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const ButtonBlue = styled.button`
  border-radius: 8px;
  background: #2d5bff !important;
  height: 40px;
  cursor: pointer;
  width: 100%;
`;

export const LightTextBlue: any = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #2d5bff;
`;

export const ContainerFooter = styled.div`
  display: flex;
  padding: 12px 12px 0 12px;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const SecondContainerFooter = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const LightTextWhite: any = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #eaefff;
`;

export const EditableField: any = styled.button<{ lineColor?: string }>`
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 4px 8px;
  font: inherit;
  color: inherit;
  text-align: left;
  border-radius: 4px;
  transition: all 0.2s ease;
  position: relative;
  &:hover {
    background-color: rgba(45, 91, 255, 0.05);
  }
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${(props: any) => props.lineColor || "#2d5bff"};
    opacity: 0.6;
  }
`;

export const CheckboxButton = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  &:hover {
    background-color: rgba(45, 91, 255, 0.1);
  }
`;

export const RowGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TableCellContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const TableColumnTitle = styled.div`
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  color: #666666;
`;

export const DashText = styled.span`
  color: #999;
  font-size: 14px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const AlignContent = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckboxWrapper: any = styled.button<{ active: boolean }>`
  cursor: pointer;
  background: ${(props: any) =>
    props.active ? "rgba(45, 91, 255, 0.1)" : "transparent"};
  border: none;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  &:hover {
    background-color: rgba(45, 91, 255, 0.15);
  }
`;

export const EditabilityHint = styled.div`
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  color: #666;
  display: flex;
  align-items: center;
  background-color: #f5f8ff;
  padding: 6px 12px;
  border-radius: 4px;
  border-left: 3px solid #2d5bff;
`;
